/** Legacy ys142857 default profile image (`public/brand/user_tou.png`). */
export const DEFAULT_USER_AVATAR = '/brand/user_tou.png';
